import { render, staticRenderFns } from "./GoliaMultiselect.vue?vue&type=template&id=5a3c2614&scoped=true"
import script from "./GoliaMultiselect.vue?vue&type=script&lang=js"
export * from "./GoliaMultiselect.vue?vue&type=script&lang=js"
import style0 from "./GoliaMultiselect.vue?vue&type=style&index=0&id=5a3c2614&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a3c2614",
  null
  
)

export default component.exports